import * as React from 'react';

const CrossSignChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.9 5H9.1L5 9.1v5.8L9.1 19h5.8l4.1-4.1V9.1L14.9 5zm.1 9.1l-.9.9-2.1-2.1L9.9 15l-.9-.9 2.1-2.1L9 9.9l.9-.9 2.1 2.1L14.1 9l.9.9-2.1 2.1 2.1 2.1z"
        />
    </svg>
);

CrossSignChunkySvg.displayName = 'CrossSignChunkySvg';
export default CrossSignChunkySvg;
